import React from "react"

import {
  CustomEvent as CustomEventType,
  CustomEventProperty,
} from "@root/store/types"
import { Button, Grid, TextField, Typography } from "@material-ui/core"
import CustomEventProperties from "./CustomEventProperties"

export interface Props {
  onCreateCustomEvent(customEvent: CustomEventType): void
}

const CustomEvent: React.FC<Props> = ({ onCreateCustomEvent }) => {
  const [name, setName] = React.useState("")
  const [value, setValue] = React.useState<number>()
  const [transactionId, setTransactionId] = React.useState<string>()
  const [interactionId, setInteractionId] = React.useState<string>()
  const [interactionType, setInteractionType] = React.useState<string>()
  const [properties, setProperties] = React.useState<CustomEventProperty[]>([])

  return (
    <Grid container spacing={2}>
      <Grid item sm={6} xs={12} data-qa-selector="custom-events-form">
        <TextField
          fullWidth
          required
          data-qa-selector="name-input"
          label="Name"
          type="text"
          id="name-id"
          value={name}
          onChange={(ev) => setName(ev.target.value)}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <TextField
          fullWidth
          data-qa-selector="value-input"
          label="Value"
          type="number"
          id="value-id"
          value={value}
          onChange={(ev) => setValue(Number(ev.target.value))}
        />
      </Grid>
      <Grid item sm={12}>
        <TextField
          fullWidth
          data-qa-selector="transaction-id-input"
          label="Transaction ID"
          type="string"
          id="transaction-id-id"
          value={transactionId}
          onChange={(ev) => setTransactionId(ev.target.value)}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <TextField
          fullWidth
          data-qa-selector="interaction-id-input"
          label="Interaction ID"
          type="text"
          id="interaction-id-id"
          value={interactionId}
          onChange={(ev) => setInteractionId(ev.target.value)}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <TextField
          fullWidth
          data-qa-selector="interaction-type-input"
          label="Interaction Type"
          type="text"
          id="interaction-type-id"
          value={interactionType}
          onChange={(ev) => setInteractionType(ev.target.value)}
        />
      </Grid>

      <Grid item sm={12}>
        <Typography variant="h5">Properties</Typography>
        <CustomEventProperties
          properties={properties}
          onAddProperty={(prop) =>
            setProperties([
              ...properties.filter(({ key }) => prop.key !== key),
              prop,
            ])
          }
          onRemoveProperty={(prop) =>
            setProperties(properties.filter(({ key }) => prop.key !== key))
          }
        />
      </Grid>
      <Grid item sm={12}>
        <Button
          onClick={(ev) => {
            ev.preventDefault()
            onCreateCustomEvent({
              name,
              value,
              transactionId,
              interactionId,
              interactionType,
              properties,
            })
          }}
          data-qa-selector="submit"
          variant="contained"
          disabled={!name}
          fullWidth
        >
          Emit Custom Event
        </Button>
      </Grid>
    </Grid>
  )
}

export default CustomEvent
